import { Link, useLocation } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const navItems = [
  { path: '/datenschutz', label: 'Datenschutz' },
  { path: '/agb', label: 'AGB' },
  { path: '/impressum', label: 'Impressum' },
  { path: '/support', label: 'Support' },
  { path: '/public/events', label: 'Events' },
  { path: '/login', label: 'Login' },
];

export const PublicHeader = () => {
  const location = useLocation();

  return (
    <header className="bg-[#1a1a1a] text-white" data-testid="public-header">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 flex items-center justify-between h-12">
        <Link to="/" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
          <span className="font-['Oswald'] text-sm font-bold tracking-wider">S.H.R.T.</span>
          <span className="text-[10px] text-white/50 uppercase tracking-widest hidden sm:inline">Swiss Historic Racing Team</span>
        </Link>
        <nav className="flex items-center gap-1 sm:gap-4 text-[11px] sm:text-xs uppercase tracking-wider">
          {navItems.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={`transition-colors px-1 py-1 ${
                location.pathname === item.path
                  ? 'text-[#c41e1e] font-semibold'
                  : 'text-white/70 hover:text-white'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
};
